// ESM-Konvertierung von lib/scripts/CLS_CSound.js (Phase 4, Welle 1a).
export class CSound {
  constructor() {
    this.abeep = new Audio('lib/sounds/beep1.wav');
  }

  playFile(file) {
    if (POS.EnvProperties.SOUNDDEVICE == "NO" || silent)
      return;
    const alarm = new Audio(POS.EnvProperties.CASHBOXALARM);
    alarm.play();
  }

  beep() {
    if (POS.EnvProperties.SOUNDDEVICE == "NO" || silent)
      return;
    this.abeep.play();
  }
}
